// Month options for recording a payment.
//
// Newest first, matching the wireframe, because the overwhelmingly common case
// is recording the current month and it should be the default without scrolling.
//
// Values are 'YYYY-MM'. The server normalises to the first of the month, so the
// day never has to travel and cannot pick up a timezone on the way.

const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export function recentMonths(count = 6, now = new Date()) {
  return Array.from({ length: count }, (unused, index) => {
    const date = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - index, 1));
    const value = `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}`;
    return { value, label: `${MONTH_NAMES[date.getUTCMonth()]} ${date.getUTCFullYear()}` };
  });
}

export function monthLabel(value) {
  if (!value) return '';
  const [year, month] = String(value).split('-');
  const index = Number(month) - 1;
  if (!MONTH_NAMES[index]) return String(value);
  return `${MONTH_NAMES[index]} ${year}`;
}
